<div class="container">
  <section class="contact-us">
    <div class="main-title">
      <span class="text-hover-animation">Связаться с нами</span>
    </div>
    <div class="contact-us-row">

      <img class="contact-us-img" src="../../../assets/img/contact-us-img.svg" alt="image">
      <div class="contact-us-container">
        <div class="contact-us-item">
          <div class="contact-us-item-sub-container">
            <div class="contact-us-item-container">
              <img src="../../../assets/img/contact/contact-us-mail.svg" alt="icon">
              <a class="contact-us-link" href="mailto:support@busy-fly.com">support@busy-fly.com</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
